import { start as startCdp } from "./cdp";
import { start as startUserCounting } from "./user-counting";
export async function start() {
    await startCdp();
    await startUserCounting();
}
